import React from 'react';
import Popup from '../../Popup';
import links from '../../../../config/links';

const IncompleteApplicationPopup = ({ onCloseClick, onSaveClick, submitting, buttonText }) => {
    return (
        <Popup
            className="popup-sm"
            onCloseClick={onCloseClick}
            data-testid="modal.incomplete-application"
            config={{
                fullScreen: false,
                noPadding: true,
                scrollable: false,
                /* style: {
                        //height: '370px',
                        //width: '600px'
                    } */
            }}
        >
            <div className="popup-section p24 pt0">
                <h5 data-testid="modal.incomplete-application.heading"><span className="text-gray">Your application is in </span>review.</h5>
            </div>
            <div className="popup-section p24 pt0">
                <p data-testid="modal.incomplete-application.description">Verified events can only be published once your Club gets approved. Approval usually takes 24-48 hours. We&apos;ll notify you by email if you&apos;re approved.</p>
                <p data-testid="modal.incomplete-application.questions-text">Have questions about your application?<br />Contact our <a rel="noopener noreferrer" target="_blank" href={links.support} data-testid="modal.incomplete-application.support-link">Support team</a>.</p>
                <div className="mt24">
                    <div className="row">
                        <div className="col-12">
                            <div className="div mb24" />
                            <button
                                type="button"
                                className="btn btn-default btn-default text-uppercase btn-block"
                                onClick={onSaveClick}
                                disabled={submitting}
                                data-testid="modal.incomplete-application.save-btn"
                            >
                                {submitting ? 'Saving...' : buttonText || 'Save Event'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default IncompleteApplicationPopup;
